import { render, staticRenderFns } from "./DocumentsBusiness.vue?vue&type=template&id=6cd20834&scoped=true&"
import script from "./DocumentsBusiness.vue?vue&type=script&lang=js&"
export * from "./DocumentsBusiness.vue?vue&type=script&lang=js&"
import style0 from "./DocumentsBusiness.vue?vue&type=style&index=0&id=6cd20834&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cd20834",
  null
  
)

export default component.exports